import { render } from "./BlackFriday20Header.vue?vue&type=template&id=17b131ae&scoped=true"
import script from "./BlackFriday20Header.vue?vue&type=script&lang=js"
export * from "./BlackFriday20Header.vue?vue&type=script&lang=js"

import "./BlackFriday20Header.vue?vue&type=style&index=0&id=17b131ae&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b131ae"]])

export default __exports__